export default {
	defaultDuration: 400,
	element: document.createElement("DIV"),
	identity: () => {},
};
